<template>
  <div class="navber_box clearfix">
    <div class="navber_left">
      <img class="navber_logo" v-if="logo" :src="logo" alt="">
      <img class="navber_logo" v-else src="../../assets/logo.png" alt="">
      <div class="navber_btns">
        <div class="navber_btn" :class="[navber_btn_value==='/' ? 'active' : '']"
             @click="chabtnval('/')">
          <img v-if="navber_btn_value==='/'" style="width: 26px;" class="navber_btn_img"
               src="../../assets/wenzhenshi_bai.png" alt="">
          <img v-else class="navber_btn_img" src="../../assets/wenzhenshi_hui.png" alt="">
          <span>问诊室</span>
        </div>
        <div class="navber_btn" :class="[navber_btn_value==='/orderList' ? 'active' : '']"
             @click="chabtnval('/orderList')">
          <img v-if="navber_btn_value==='/orderList'" style="width: 18px;" class="navber_btn_img"
               src="../../assets/wenzhenjilu_bai.png" alt="">
          <img v-else class="navber_btn_img" src="../../assets/wenzhenjilu_hui.png" alt="">
          <span>问诊记录</span>
        </div>
      </div>
    </div>
    <div class="navber_right">
      <div class="username">{{ wx_name }}</div>
      <el-popover placement="bottom" trigger="click">
        <div class="statepop_box">
          <p class="statepop_text">在线状态</p>
          <ul class="statepop_ul clearfix">
            <li @click="chastate(1)" class="statepop_li" :class="[remote_state===1 ? 'stateactive' : '']">
              在线
              <img v-if="remote_state===1" src="../../assets/zaixian_bai.png" alt="">
              <img v-else src="../../assets/zaixian_lv.png" alt="">
            </li>
            <li @click="chastate(0)" class="statepop_li" :class="[remote_state===0 ? 'stateactive' : '']">
              离线
              <img v-if="remote_state===0" src="../../assets/lixian_bai.png" alt="">
              <img v-else src="../../assets/lixian_lv.png" alt="">

            </li>
            <li @click="chastate(2)" class="statepop_li" :class="[remote_state===2 ? 'stateactive' : '']">
              忙线
              <img v-if="remote_state===2" src="../../assets/mangxian_bai.png" alt="">
              <img v-else src="../../assets/mangxian_lv.png" alt="">
            </li>
          </ul>
        </div>
        <div class="state_box" slot="reference">
          <span class="state_text" v-if="remote_state===1">在线</span>
          <span class="state_text" v-else-if="remote_state===0">离线</span>
          <span class="state_text" v-else-if="remote_state===2">忙线</span>
          <img class="state_img" src="../../assets/zaixian_lv.png" alt="" v-if="remote_state===1">
          <img class="state_img" src="../../assets/lixian_lv.png" alt="" v-else-if="remote_state===0">
          <img class="state_img" src="../../assets/mangxian_lv.png" alt="" v-else-if="remote_state===2">
        </div>
      </el-popover>
      <img @click="openchapwddialog" class="setting" src="../../assets/setting.png" alt="">
    </div>
    <el-dialog
        class="chapwddialog"
        title=""
        :visible.sync="chapwddialog"
        width="284px">
      <el-form ref="chapwddialogform" :model="chapwddialogform" :rules="chapwddialogrule"
               label-width="0" style="border-bottom: 1px solid #CCCCCC;">
        <div class="chapwddialogform">
          <el-form-item label="" prop="login_name">
            <el-input v-model="chapwddialogform.login_name" clearable placeholder="请输入账号"/>
          </el-form-item>
          <el-form-item label="" prop="newpwd">
            <el-input type="password" v-model="chapwddialogform.newpwd" clearable placeholder="请输入密码"/>
          </el-form-item>
          <el-checkbox v-model="checked">确认修改账号密码</el-checkbox>
          <div style="margin-top:20px;text-align: center">
            <el-button class="dialog-btn" @click="chapwdbtn">修改密码</el-button>
          </div>
        </div>
      </el-form>
      <div @click="logout" class="closedialog">
        <i style="font-size: 19px;color: #F65655;margin-right: 4px" class="el-icon-circle-close"></i>
        退出登陆
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import router from "../../router";

export default {
  name: "navber",
  data() {
    return {
      logo: Cookies.get('logo'),
      wx_name: Cookies.get('wx_name'),
      navber_btn_value: 'wenzhenshi',
      remote_state: '',
      chapwddialog: false,
      chapwddialogform: {
        login_name: '',
        newpwd: '',
      },
      chapwddialogrule: {
        login_name: [
          { required: true, message: '此项为必填项' }
        ],
        newpwd: [
          { required: true, message: '此项为必填项' }
        ],
      },
      checked: true,
    }
  },
  watch: {
    '$route'(to, from) {
      this.navber_btn_value = this.$route.path
    },
  },
  created() {
    this.chabtnval()
    this.getmystate()
    this.Interval = setInterval(() => {
      this.getmystate()
    }, 10000)
  },
  methods: {
    getmystate() {
      this.$noloadingget(this.$api + '/consultation_room/get_my_state')
          .then((res) => {
            if (res.code === 0) {
              this.remote_state = res.data.remote_state
            } else {
              this.$notify({
                title: '失败',
                message: res.msg,
                type: 'error'
              });
            }
          })
    },
    chabtnval(val) {
      this.navber_btn_value = this.$route.path
      this.$router.push({
        path: val,
      })
    },
    chastate(state, logout, fun) {
      this.remote_state = state
      this.$noloadingget(this.$api + '/consultation_room/change_my_state', { remote_state: this.remote_state })
          .then((res) => {
            if (res.code === 0) {
              this.getmystate()
              if (logout === 'logout') {
                fun()
              }
            } else {
              this.$notify({
                title: '失败',
                message: res.msg,
                type: 'error'
              });
            }
          })
    },
    openchapwddialog() {
      this.chapwddialog = true
      this.chapwddialogform = {
        login_name: '',
        newpwd: '',
      };
    },
    chapwdbtn() {
      this.$refs['chapwddialogform'].validate((valid) => {
        if (valid) {
          this.$get(this.$api + '/consultation_room/change_login_info', this.chapwddialogform)
              .then((res) => {
                if (res.code === 0) {
                  this.$notify({
                    title: '成功',
                    message: res.msg,
                    type: 'success'
                  });
                  this.chastate(0, 'logout', () => {
                    this.chapwddialog = false;
                    this.$trtcCalling.logout();
                    clearInterval(this.Interval)
                    Cookies.remove('wx_name');
                    Cookies.remove('doctortoken');
                    Cookies.remove('rk_token');
                    Cookies.remove('role_id');
                    Cookies.remove('headimg');
                    Cookies.remove('UserID');
                    Cookies.remove('baseuserid');
                    Cookies.remove('logo');
                    window.localStorage.removeItem('router')
                    this.$router.push({
                      name: "login",
                    })
                  })
                } else {
                  this.$notify({
                    title: '失败',
                    message: res.msg,
                    type: 'error'
                  });
                }
              })
        }
      })
    },
    logout() {
      this.$confirm('是否退出该账号？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.chastate(0, 'logout', () => {
          this.chapwddialog = false;
          this.$trtcCalling.logout();
          clearInterval(this.Interval)
          Cookies.remove('wx_name');
          Cookies.remove('doctortoken');
          Cookies.remove('rk_token');
          Cookies.remove('role_id');
          Cookies.remove('headimg');
          Cookies.remove('UserID');
          Cookies.remove('baseuserid');
          Cookies.remove('logo');
          window.localStorage.removeItem('router')
          window.localStorage.removeItem('sdkappid')
          this.$router.push({
            name: "login",
          })
        })
      })
    },
  },
}
</script>

<style>
.chapwddialog .el-dialog__body {
  padding: 0;
}

.chapwddialog .el-form-item {
  margin-bottom: 22px;
}
</style>

<style scoped>
.navber_box {
  margin: 15px 22px 10px;
  padding: 0 30px 0 0;
  background: #FFFFFF;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
}

.navber_left {
  height: 85px;
  float: left;
  display: flex;
  align-items: center;
}


.navber_btns {
  display: flex;
}

.navber_btn {
  color: #ADBBB9;
  cursor: pointer;
  user-select: none;
  width: 116px;
  height: 46px;
  line-height: 46px;
  font-size: 16px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
}

.navber_btn.active {
  background: #1DBFC1;
  color: #ffffff;
}

.navber_btn_img {
  margin-right: 9px;
}

.navber_right {
  height: 85px;
  float: right;
  display: flex;
  align-items: center;
}

.username {
  color: #1DBFC1;
  font-size: 18px;
  margin-right: 11px;
}

.state_box {
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
  color: #1DBFC1;
  font-size: 16px;
  padding: 5px;
  border: 1px solid #1DBFC1;
  border-radius: 5px;
}

.state_img {
  margin-left: 4px;
}

.statepop_box {
  padding: 14px 24px;
}

.statepop_text {
  color: #1DBFC1;
  font-size: 24px;
  margin: 0 0 10px 8px;
}

.statepop_ul {
  font-size: 16px;
  color: #1DBFC1;
  background: #DBF0ED;
  border-radius: 20px;
}

.statepop_li {
  cursor: pointer;
  user-select: none;
  width: 82px;
  height: 36px;
  line-height: 36px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.stateactive {
  border-radius: 20px;
  color: #FCFEFF;
  background: #1DBFC1;
}

.statepop_li img {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

.setting {
  cursor: pointer;
}

.chapwddialogform {
  width: 224px;
  margin: 22px auto 0;
}


.dialog-btn {
  color: #FCFEFF;
  font-size: 14px;
  width: 224px;
  height: 39px;
  background: #1DBFC1;
  border-radius: 5px;
  margin: 0 auto 20px;
}

.closedialog {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  height: 53px;
  line-height: 53px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/navber.vue